import {useContext, useEffect} from 'react'
import StoreContext from '../../stores/StoreContext'

export const StaticLoader = () => {
    const stores = useContext(StoreContext)
    useEffect(() => {
        stores?.staticStore.getStatic()
    }, [])
    return null
}